import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Title from '../../Components/Labels/Title';
import FooterStepper from '../../Components/Stepper/FooterStepper';
import { history } from '../../Routes/history';
import { ROUTE_NAMES } from '../../Routes/Routes';
import {
  ConstructorRequestTitle,
  ConstructorRequestType
} from '../../Enums/constructors';
import ConstructorRequestForm from './ConstructorRequestForm/ConstructorRequestStepperForm';
import { UserContext } from '../../Contexts/UserContext';
import { get as _get } from 'lodash';
import ModalAlert from '../../Components/Alerts/Modals/ModalAlert';
import BaseBreadcrumbs from '../../Components/Breadcrumbs/BaseBreadcrumbs';
import { Company } from '../../Configs/general';
import { ConstructorContractsContext } from '../../Contexts/ContractsContext';
import RequestInformation from './RequestInformation/RequestInformation';

const FORM_ID = 'Constructor_request_form';

const ConstructorsRequestGDC = ({
  match: {
    params: { contractId: paramsContractId, requestType }
  },
  location: { state: { constructorInfo, displayBreadcrumb = false } = {} }
}) => {
  const classes = useStyles();
  const breadcrumbClasses = useMemo(
    () => ({
      root: classes.breadcrumbRoot
    }),
    [classes]
  );

  const [nextButtonText, setNextButtonText] = useState('Siguiente');
  const [goBack, setGoBack] = useState({});
  const [canSubmit, setCanSubmit] = useState(false);
  const [loading, setLoading] = useState(false);

  const constructorContracts = useContext(ConstructorContractsContext);
  const currentUser = useContext(UserContext);
  const authToken = _get(currentUser, 'token');

  const contractId = paramsContractId && Number(paramsContractId);

  useEffect(() => {
    const requestTypeExists =
      requestType &&
      Object.values(ConstructorRequestType).includes(requestType);

    const isInvalidContractId = contractId && Number.isNaN(contractId);

    const hasValidConstructorInfo =
      constructorInfo && Object.keys(constructorInfo).length > 0;

    if (
      !authToken ||
      !requestTypeExists ||
      !hasValidConstructorInfo ||
      isInvalidContractId
    ) {
      history.push(ROUTE_NAMES.constructors);
      return;
    }

    if (!contractId) {
      return;
    }

    const constructorContract =
      constructorContracts &&
      constructorContracts.find(contract => contract.id === contractId);

    if (!constructorContract) {
      history.push(ROUTE_NAMES.constructors);
      return;
    }
  }, [
    requestType,
    constructorInfo,
    contractId,
    constructorContracts,
    authToken
  ]);

  return (
    <>
      {loading && <ModalAlert type="info" message="Creando solicitud..." />}
      <Container maxWidth="md" className={classes.root}>
        {displayBreadcrumb && (
          <BaseBreadcrumbs
            classes={breadcrumbClasses}
            separator=">"
            breadcrumbs={[
              {
                link: ROUTE_NAMES.constructors,
                name: 'Proyectos'
              },
              {
                link: `${ROUTE_NAMES.constructorPhase}/${contractId}`,
                name: `Detalle ${Company.contractConjugation.regular.singular.contraction}`
              },
              {
                link: `${ROUTE_NAMES.constructorRequest}/${requestType}/${contractId}`,
                name: ConstructorRequestTitle[requestType]
              }
            ]}
          />
        )}
        <Title
          className={classes.title}
          text={ConstructorRequestTitle[requestType]}
        />
        <RequestInformation type={requestType} />
        <ConstructorRequestForm
          formId={FORM_ID}
          authToken={authToken}
          type={requestType}
          contractId={contractId}
          setCanSubmit={setCanSubmit}
          setLoading={setLoading}
          setGoBack={setGoBack}
          setNextButtonText={setNextButtonText}
          constructorInfo={constructorInfo}
        />
      </Container>
      <FooterStepper
        targetForm={FORM_ID}
        disabledNext={!canSubmit}
        goBack={goBack}
        nextButtonText={nextButtonText}
      />
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    paddingBottom: theme.custom.footerHeight.stepper
  },
  title: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(2)
  },
  breadcrumbRoot: {
    marginBottom: theme.spacing(2)
  }
}));

export default ConstructorsRequestGDC;
